module.exports = __webpack_public_path__ + "img/ypogeiaathinalogo.039cf7f0.jpg";